import { render, staticRenderFns } from "./counsels-requestees.vue?vue&type=template&id=06a6ffc4&"
import script from "./counsels-requestees.vue?vue&type=script&lang=js&"
export * from "./counsels-requestees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports